import '../sass/base.scss'
import '../sass/webapp.scss'

import React from "react";
import ReactDOM from "react-dom";

import Common from './Common';

import FirmwareManagement from "./Helper/FirmwareManagement";
import ProductManagement from './Helper/ProductManagement';
import AccountManagement from './Helper/AccountManagement';
import InvoiceItemList from './Helper/InvoiceItemList'
import DashboardStatistics from './Statistics/DashboardStatistics';
import DashboardLeftManagement from './Helper/DashboardLeftManagement';
import DashboardRightManagement from './Helper/DashboardRightManagement';
import ChargeMeterTimeline from "./Helper/ChargeMeterTimeline";

import SearchTableNotification from './SearchTable/SearchTableNotification';
import SearchTableBank from './SearchTable/SearchTableBank';
import SearchTableDownload from './SearchTable/SearchTableDownload';
import SearchTableFirmware from './SearchTable/SearchTableFirmware';
import SearchTableCashpoint from "./SearchTable/SearchTableCashpoint";
import SearchTableProduct from './SearchTable/SearchTableProduct';
import SearchTableProductCategory from './SearchTable/SearchTableProductCategory';
import SearchTableAccount from './SearchTable/SearchTableAccount';
import SearchTableToken from './SearchTable/SearchTableToken';
import SearchTableInvoice from './SearchTable/SearchTableInvoice';
import SearchTableCharge from './SearchTable/SearchTableCharge';
import SearchTableOrder from './SearchTable/SearchTableOrder';
import SearchTableTransfer from './SearchTable/SearchTableTransfer';
import SearchTableManufacturer from "./SearchTable/SearchTableManufacturer";
import SearchTableHardware from "./SearchTable/SearchTableHardware";

import ChargeStatistics from './Statistics/ChargeStatistics';
import OrderStatistics from './Statistics/OrderStatistics';
import ChargeDiagrams from './Statistics/ChargeDiagrams';

import SearchTableRefund from "./SearchTable/SearchTableRefund";
import SearchTableTransferTransaction from "./SearchTable/SearchTableTransferTransaction";
import OperatorPicker from "./Pickers/OperatorPicker";
import NewOperatorSelector from "./Helper/NewOperatorSelector";

$(document).ready(function () {
    window.common = new Common();
    /*
     * Helpers
     */
    if (document.getElementById('account-form') || document.getElementById('account-b2b-form')) {
        window.accountManagement = new AccountManagement();
    }
    let helperObjects = {
        'product-form': ProductManagement,
        'firmware-form': FirmwareManagement
    }

    for (const [html_id, HelperClass] of Object.entries(helperObjects)) {
        if (document.getElementById(html_id)) {
            window[HelperClass.name.charAt(0).toLowerCase() + HelperClass.name.slice(1)] = new HelperClass();
        }
    }

    if ($('#dashboard').length) {
        if ($('#dashboard-transfers').length) {
            ReactDOM.render(
                <DashboardStatistics ref={(dashboardStatistics) => {window.dashboardStatistics = dashboardStatistics}} />,
                document.getElementById("dashboard-transfers")
            );
        }
        ReactDOM.render(
            <DashboardRightManagement ref={(dashboardRightManagement) => {window.dashboardRightManagement = dashboardRightManagement}} />,
            document.getElementById("dashboard-right")
        );
        ReactDOM.render(
            <DashboardLeftManagement ref={(dashboardLeftManagement) => {window.dashboardLeftManagement = dashboardLeftManagement}} />,
            document.getElementById("dashboard-left")
        );
    }
    /*
     react loader
     */
    let reactObjects = {
        'invoice-item-list': InvoiceItemList,
        'charge-meter-timeline': ChargeMeterTimeline,

        // search tables
        'notification-search-results': SearchTableNotification,
        'download-search-results': SearchTableDownload,
        'bank-search-results': SearchTableBank,
        'manufacturer-search-results': SearchTableManufacturer,
        'hardware-search-results': SearchTableHardware,
        'firmware-search-results': SearchTableFirmware,
        'cashpoint-search-results': SearchTableCashpoint,
        'product-search-results': SearchTableProduct,
        'product-category-search-results': SearchTableProductCategory,
        'account-search-results': SearchTableAccount,
        'token-search-results': SearchTableToken,
        'invoice-search-results': SearchTableInvoice,
        'charge-search-results': SearchTableCharge,
        'order-search-results': SearchTableOrder,
        'transfer-search-results': SearchTableTransfer,
        'refund-search-results': SearchTableRefund,
        'transfer-transaction-search-results': SearchTableTransferTransaction,

        // statistics
        'charge-statistics-product-results': ChargeStatistics,
        'order-statistics-product-results': OrderStatistics,
        'charge-diagram-results': ChargeDiagrams
    };
    for (const [html_id, ReactClass] of Object.entries(reactObjects)) {
        if (document.getElementById(html_id)) {
            ReactDOM.render(
                <ReactClass ref={(reactClass) => {window[ReactClass.name.charAt(0).toLowerCase() + ReactClass.name.slice(1)] = reactClass}} />,
                document.getElementById(html_id)
            );
        }
    }


    /*
     * Other React Stuff
     */
    $('.operator-picker').each((index, obj) => {
        ReactDOM.render(
            <OperatorPicker id={$(obj).attr('data-id')}/>, obj
        )
    });

    $('.new-button').each((index, obj) => {
        ReactDOM.render(
            <NewOperatorSelector
                newUrl={obj.getAttribute('data-new-url')}
                title={obj.getAttribute('data-title')}
                enableSelector={obj.getAttribute('data-enable-selector') === '1'}
                operatorCapability={obj.getAttribute('data-operator-capability')}
            />, obj
        )
    });

    /*
     * CSRF Token renewal
     */
    const csrfField = $('#csrf_token');
    if (csrfField.length) {
        setInterval(() => {
            $.getJSON('/api/common/csrf', (result) => {
                csrfField.val(result.csrf);
                csrfField.change()
            })
        }, 480000) //8 Minutes
    }

});


window.googleMapsLoaded = new $.Deferred();
window.setGoogleMapsLoaded = function() {
    window.googleMapsLoaded.resolve();
};
